import { render } from "./Passkey.vue?vue&type=template&id=40d95d3d"
import script from "./Passkey.vue?vue&type=script&lang=js"
export * from "./Passkey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__